import { Modal } from "~/components/AccountActions/modal.web";
import SaveFormFormProvider from "~/components/SaveForm/SaveForm.formProvider";
import { SaveFormFormProviderProps } from "~/components/SaveForm/shared";

export default function SaveFormDialog({
  onDismiss: onDismiss,
  ...rest
}: {
  onDismiss: () => void;
} & SaveFormFormProviderProps) {
  return (
    <Modal onDismiss={onDismiss}>
      <SaveFormFormProvider {...rest} />
    </Modal>
  );
}
